import { type NavItem } from '@/component/Navigation/types';
import { Icon } from '@/icon/Icon';
import { rmsReportsFullPath } from '@/view/pathDefinitions';

export const rmsNavItems: NavItem[] = [
  {
    to: rmsReportsFullPath,
    icon: <Icon name="lab_profile" size="small" />,
    label: ({ rms }) => rms.reports.header,
    access: (permissions) => permissions.includes('rms.report:w'),
  },
];
